/**
 * 百度 Seedance 返回的是自有任务 ID（tsk-），上游方舟任务 ID 在查询结果的 service_job_id。
 * 样片转正式时百度把 content 原样透传给方舟，draft_task.id 必须换成方舟任务 ID。
 */
export async function resolveBaiduDraftTaskId<T extends Record<string, any>>(
    payload: T,
    getTask: (taskId: string) => Promise<any>,
): Promise<T> {
    if (!Array.isArray(payload?.content)) return payload;
    const idx = payload.content.findIndex(
        (item: any) => item?.type === 'draft_task' && typeof item?.draft_task?.id === 'string',
    );
    if (idx < 0) return payload;

    const taskId: string = payload.content[idx].draft_task.id;
    const task = await getTask(taskId);
    const upstreamId = task?.service_job_id;
    if (typeof upstreamId !== 'string' || !upstreamId) {
        throw new Error(`Baidu draft task ${taskId} has no service_job_id`);
    }

    const content = [...payload.content];
    content[idx] = { ...content[idx], draft_task: { id: upstreamId } };
    return { ...payload, content };
}
